<template>

    <main role="main" class="page" id="landingPage">

        <!-- Featured posts -->
        <section class="featured-articles" v-show="latest" v-bind:class="{'hidden-content': !displayContent}">

            <div class="container">

                <div class="row no-gutters slick-slider">

                    <div v-for="item in latest.slice(0,3)" class="col-12 col-sm-4">

                        <blog-featured :blog="item"></blog-featured>

                    </div>

                </div>

            </div>

        </section>

        <!-- Latest posts -->
        <section class="latest-posts" v-show="latest" v-bind:class="{'hidden-content': !displayContent}">

            <div class="container">

                <div class="row">

                    <div class="col text-center">

                        <h2 class="text-uppercase">Zadnje objave</h2>
                        <div class="divider-image divider-image-2"></div>

                    </div>
                </div>

                <div class="row mb-4">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <div class="masonry">

                            <div v-for="item in latest.slice(3,12)" class="grid-item">

                                <blog-tile :blog="item"></blog-tile>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </section>

        <!-- Instagram feed -->
        <instagram-feed v-bind:class="{'hidden-content': !displayContent}"></instagram-feed>

        <!-- More posts -->
        <section class="latest-posts" v-show="latest" v-bind:class="{'hidden-content': !displayContent}">

            <div class="container">

                <div class="row">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <div class="masonry">

                            <div v-for="item in latest.slice(12)" class="grid-item">

                                <blog-tile :blog="item"></blog-tile>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-2 mt-4" v-if="latest && latest.length % 10 === 0">

                    <div class="col text-center">

                        <a href="javascript:" @click="loadBlogPosts(10, latest.length)" class="load-more btn btn-danger">
                            <i class="fal" :class="{'fa-spinner-third': loadingContent, 'fa-spin': loadingContent, 'fa-caret-down': !loadingContent }"></i> &nbsp; Naloži več &nbsp;
                        </a>

                    </div>
                </div>
            </div>
        </section>

    </main>

</template>

<script>
    import BlogFeatured from '../snippets/blog/Featured.vue';
    import BlogTile from '../snippets/blog/Tile.vue';
    import InstagramFeed from '../snippets/InstagramFeed.vue';
    import {mapState, mapActions} from 'vuex'
    import {baseSEO} from "../config";

    export default {

        props: [
            "preview"
        ],

        components: {
            "blog-featured":  BlogFeatured,
            "blog-tile":  BlogTile,
            "instagram-feed": InstagramFeed
        },

        data () {
            return {
                displayContent: false,
                loadingContent: false,
            }
        },

        computed: {


            ...mapState([
                'latest',
                'banners'
            ]),
        },

        methods: {

            ...mapActions([
                'getBlogItems',
                'loadBanners'
            ]),

            updateGrid: function() {

                let handle = this;

                jQuery(document).ready(function() {

                    setTimeout(function () {

                        initMasonry();

                        initSlickSlider();

                        handle.loadingContent = false;
                        handle.displayContent = true;

                        initInstagramFeed();

                        setTimeout(function() {

                            initMatchHeightPlugin();

                        }, 350);

                    }, 250);
                });
            },

            loadBlogPosts: function(take, skip = null, override = false, exclude = []) {

                let handle = this;

                if(!override) this.loadingContent = true;

                this.getBlogItems({take, skip, override, exclude}).then(function() {

                    handle.updateGrid();

                }).catch(function(error) {

                    console.log(error);

                }).finally(function() {

                    handle.loadingContent = false;
                });
            },

            getBanners: function() {

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.loadBanners().then(function(banners) {

                    if(banners.length > 0 && banners[0].image !== null && typeof banners[0].image !== "undefined") {

                        mainBackgroundImage.style.backgroundImage = "url("+handle.displayImage(banners[0].image, 2200)+")";
                    }
                });
            }

        },

        mounted: function() {

            let handle = this;

            if(this.latest.length === 0) this.loadBlogPosts(25, null, true);
            else handle.updateGrid();

            this.getBanners();
        },

        metaInfo () {

            return {

                title: baseSEO.name,
                meta: [
                    { author : baseSEO.author },
                    { description : baseSEO.description },
                    { keywords : baseSEO.keywords },

                    // Facebook
                    {property: 'og:title', content: baseSEO.title },
                    {property: 'og:site_name', content: baseSEO.name },
                    {property: 'og:type', content: 'website'},
                    {property: 'og:url', content: baseSEO.url },
                    {property: 'og:image', content: baseSEO.image },
                    {property: 'og:description', content: baseSEO.description },

                    // Twitter card
                    {name: 'twitter:card', content: 'summary'},
                    {name: 'twitter:site', content: baseSEO.url },
                    {name: 'twitter:title', content: baseSEO.name },
                    {name: 'twitter:description', content: baseSEO.description },
                    {name: 'twitter:image:src', content: baseSEO.image },

                    // Google / Schema.org markup:
                    {itemprop: 'name', content: baseSEO.name },
                    {itemprop: 'description', content: baseSEO.description },
                    {itemprop: 'image', content: baseSEO.image }
                ],
                links: [
                    {rel: 'canonical', href: baseSEO.url }
                ]
            }
        },
    }
</script>

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pages/Landing.vue